import { z } from 'zod/v4'
import { permissionsSchema } from './permission'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const roleSchema = z.object({
    created_at: zDayJs.nullish(),
    name: z.string().nullish(),
    permissions: permissionsSchema.nullish(),
    scope: z.string().nullish(),
    scope_for_human: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const rolesSchema = z.array(roleSchema)

export const paginatedRolesResponseSchema = z.object({
    data: rolesSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveRoleResponseSchema = z.object({
    data: roleSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type Role = z.infer<typeof roleSchema>
export type Roles = z.infer<typeof rolesSchema>
export type PaginatedRolesResponse = z.infer<typeof paginatedRolesResponseSchema>
export type RetrieveRoleResponse = z.infer<typeof retrieveRoleResponseSchema>
